import React from 'react';
import { motion } from 'framer-motion';
import { Undo2, Redo2 } from 'lucide-react';

export default function FloatingUndoButton({ canUndo, canRedo, onUndo, onRedo }) {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex gap-2 bg-white/90 backdrop-blur-sm border border-gray-200 rounded-lg shadow-lg p-1">
      <motion.button
        className={`p-2.5 rounded-md transition-all ${
          canUndo 
            ? 'text-gray-700 hover:bg-gray-100 cursor-pointer' 
            : 'text-gray-300 cursor-not-allowed'
        }`}
        whileHover={canUndo ? { scale: 1.05 } : undefined}
        whileTap={canUndo ? { scale: 0.95 } : undefined}
        onClick={canUndo ? onUndo : undefined}
        disabled={!canUndo}
        title="Отменить (Ctrl+Z)"
      >
        <Undo2 size={18} />
      </motion.button>

      <div className="w-px bg-gray-200" />

      <motion.button
        className={`p-2.5 rounded-md transition-all ${
          canRedo 
            ? 'text-gray-700 hover:bg-gray-100 cursor-pointer' 
            : 'text-gray-300 cursor-not-allowed'
        }`}
        whileHover={canRedo ? { scale: 1.05 } : undefined}
        whileTap={canRedo ? { scale: 0.95 } : undefined}
        onClick={canRedo ? onRedo : undefined}
        disabled={!canRedo}
        title="Повторить (Ctrl+Shift+Z)"
      >
        <Redo2 size={18} />
      </motion.button>
    </div>
  );
}
